import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authUser = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['getUser']),
}

export const companyComputed = {
  ...mapState('company', {
    company: (state) => state.company,
  }),
  ...mapGetters('company', ['getCompany']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    leftSidebarSize: (state) => state.leftSidebarSize,
    menuPosition: (state) => state.menuPosition,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType','changeLeftSidebarSize', 'changeTopbar', 'changeLoaderValue', 'changeMenuPosition'])
export const authMethods = mapActions('auth', ['login', 'logout'])
export const companyMethods = mapActions('company', ['addCompany', 'removeCompany'])
export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
